// DEUTSCH — Übersetzung als Lesehilfe. Rechtsverbindlich ist allein die französische Fassung (siehe fr.js).

import { COURRIEL, TELEPHONE, adresseVendeur, encadreIdentite } from './identite';

const ADRESSE = adresseVendeur('Belgien');
const TRADUCTION =
  'Diese Übersetzung dient Ihrer Information. Bei Abweichungen ist ausschließlich die französische Fassung rechtsverbindlich.';

export default {
  cgv: {
    seoTitre: 'Allgemeine Geschäftsbedingungen',
    seoDescription:
      'Allgemeine Geschäftsbedingungen von MirumGames: Bestellung, Preise, Zahlung, 14-tägiges Widerrufsrecht, Lieferung und Gewährleistung.',
    titre: 'Allgemeine Geschäftsbedingungen',
    maj: 'Letzte Aktualisierung: 23.09.2026',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: 'Artikel 1: Allgemeines',
        blocs: [
          { p: 'Jede auf MIRUMGAMES.COM aufgegebene Bestellung setzt die vorherige Annahme dieser Geschäftsbedingungen voraus. Die Kundin oder der Kunde bestätigt, deren Inhalt vorbehaltlos gelesen und angenommen zu haben.' },
        ],
      },
      {
        titre: 'Artikel 2: Gegenstand',
        blocs: [
          { p: 'Diese Geschäftsbedingungen regeln die Rechte und Pflichten der Parteien beim Online-Verkauf der von MirumGames.com angebotenen Produkte und Dienstleistungen an Verbraucherinnen und Verbraucher.' },
        ],
      },
      {
        titre: 'Artikel 3: Preise und Zahlung',
        blocs: [
          { p: 'Die Preise verstehen sich in Euro und enthalten die geltende Mehrwertsteuer. Versandkosten sind nicht enthalten und werden gesondert berechnet. Die vollständige Zahlung erfolgt bei Bestätigung der Bestellung.' },
          { p: 'MirumGames.com akzeptiert Kartenzahlungen über STRIPE, einen zertifizierten und sicheren Zahlungsdienstleister.' },
          { p: 'Für jede bezahlte Bestellung wird eine Rechnung auf den Namen des Käufers ausgestellt. Sie ist auf der Bestellbestätigungsseite, über den Link in der Bestätigungs-E-Mail und – für Kunden mit Konto – unter „Meine Bestellungen“ abrufbar. Stripe sendet zusätzlich eine Zahlungsquittung per E-Mail.' },
        ],
      },
      {
        titre: 'Artikel 4: Widerrufsrecht',
        blocs: [
          { p: 'Privatkundinnen und -kunden haben 14 Tage Zeit, Produkte zurückzusenden, die ihnen nicht zusagen. Die Frist beginnt am Tag der Lieferung.' },
          { p: 'Bedingungen für die Rücksendung:' },
          {
            liste: [
              'Die Produkte müssen in der Originalverpackung und in einwandfrei wiederverkäuflichem Zustand zurückgesandt werden',
              'Produkte mit Gebrauchsspuren werden nicht angenommen',
              'Die Rücksendekosten trägt die Verbraucherin oder der Verbraucher',
              'Die Erstattung erfolgt innerhalb von 15 Tagen per Banküberweisung',
            ],
          },
        ],
      },
      {
        titre: 'Artikel 5: Gewährleistung',
        blocs: [
          { p: 'MirumGames.com gewährleistet die Produkte gegen verborgene Mängel nach belgischem Recht. MirumGames.com ist nicht Herstellerin der angebotenen Artikel und übernimmt keine Haftung für Schäden, die durch einen Produktfehler entstehen.' },
          { p: 'Die Haftung des Verkäufers beschränkt sich auf den Umtausch oder die Erstattung des mangelhaften Produkts.' },
        ],
      },
      {
        titre: 'Artikel 6: Verfügbarkeit der Produkte',
        blocs: [
          { p: 'Die Angebote gelten solange der Vorrat reicht. Abbildungen, Farben, Maße und Gewichte dienen nur der Information und sind nicht vertraglich bindend. MirumGames.com übernimmt keine Haftung für Abweichungen der Produkteigenschaften.' },
        ],
      },
      {
        titre: 'Artikel 7: Lieferung',
        blocs: [
          { p: 'Die Produkte werden an die im Bestellformular angegebene Adresse geliefert. Es muss sich um eine physische Adresse handeln (kein Postfach).' },
          { p: 'Wir versenden nach Belgien, Frankreich, Luxemburg, in die Niederlande, nach Deutschland und Spanien. Durchschnittliche Lieferzeiten:' },
          {
            liste: [
              'Luxemburg, Belgien, Niederlande: 1 bis 2 Werktage',
              'Frankreich, Deutschland: 2 bis 4 Werktage',
              'Spanien: 4 bis 5 Werktage',
            ],
          },
          { p: 'Hinweis: Die Bearbeitungszeit (im Schnitt 1 Werktag) kommt hinzu.' },
        ],
      },
      {
        titre: 'Artikel 8: Übereinstimmung der Lieferung',
        blocs: [
          { p: 'Bei Erhalt ist zu prüfen, ob die Produkte mit der Bestellung übereinstimmen. Jeder Mangel ist handschriftlich auf dem Lieferschein zu vermerken.' },
          { p: 'Jede Abweichung (fehlendes oder beschädigtes Produkt usw.) ist MirumGames.com innerhalb von 96 Stunden nach der Versandbenachrichtigung mitzuteilen.' },
        ],
      },
      {
        titre: 'Artikel 9: Haftung',
        blocs: [
          { p: 'MirumGames.com haftet nicht für Schäden, die nach der Lieferung durch unsachgemäßen Gebrauch oder unsachgemäße Handhabung der Produkte entstehen.' },
        ],
      },
      {
        titre: 'Artikel 10: Anwendbares Recht',
        blocs: [
          { p: 'Diese Geschäftsbedingungen unterliegen belgischem Recht. Im Streitfall wird gebeten, zunächst MirumGames.com zu kontaktieren, um eine gütliche Lösung zu finden.' },
        ],
      },
      {
        titre: 'Impressum',
        blocs: [
          { p: 'Die vollständigen rechtlichen Angaben des Unternehmens (Kontaktdaten, USt-IdNr. usw.) finden Sie in unserem <a href="/legal" class="text-blue-600 hover:text-blue-800 underline">Impressum</a>.' },
          { p: 'Bei Bestellungen, deren Zahlung bis einschließlich 22.09.2026 (belgische Zeit) eingegangen ist, ist Charlotte Ansiaux (ZDU 1000.107.018) die Verkäuferin und bleibt es; bei Bestellungen, deren Zahlung ab dem 23.09.2026 eingeht, ist Sébastien Schoonjans der Verkäufer.' },
        ],
      },
    ],
  },

  confidentialite: {
    seoTitre: 'Datenschutzerklärung',
    seoDescription:
      'Datenschutzerklärung von MirumGames: erhobene Daten, Verwendung, Cookies, anonyme Reichweitenmessung und Ihre Rechte nach DSGVO.',
    titre: 'Datenschutzerklärung',
    maj: 'Letzte Aktualisierung: 23.09.2026',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: '1. Erhebung personenbezogener Daten',
        blocs: [
          { p: 'MirumGames.com erhebt die personenbezogenen Daten, die erforderlich sind, um:' },
          {
            liste: [
              'Ihre Bestellung zu bearbeiten (Name, Adresse, E-Mail, Telefon)',
              'Ihnen Bestellbestätigungen und Lieferbenachrichtigungen zu senden',
              'Ihr Kundenkonto zu verwalten',
              'Ihnen unsere Newsletter zu senden (mit Ihrer Einwilligung)',
              'Unsere Leistungen zu verbessern',
            ],
          },
        ],
      },
      {
        titre: '2. Verwendung der Daten',
        blocs: [
          { p: 'Ihre Daten werden ausschließlich für die oben genannten Zwecke verwendet. MirumGames.com gibt Ihre Daten niemals ohne Ihre ausdrückliche Einwilligung an Dritte weiter.' },
          { p: 'Die einzigen Ausnahmen sind:' },
          {
            liste: [
              'Logistikdienstleister für die Zustellung',
              'STRIPE für die Zahlungsabwicklung',
              'Behörden, sofern das Gesetz es verlangt',
            ],
          },
        ],
      },
      {
        titre: '3. Cookies',
        blocs: [
          { p: 'MirumGames.com verwendet Cookies, um Ihre Nutzung zu verbessern, insbesondere um:' },
          {
            liste: [
              'Ihre Navigationseinstellungen zu speichern',
              'Ihren Warenkorb zu verwalten',
              'Ihr Erlebnis zu personalisieren',
            ],
          },
          { p: 'Sie können Cookies jederzeit in den Einstellungen Ihres Browsers deaktivieren. Das kann jedoch die Funktion der Website beeinträchtigen.' },
          { p: '<strong>Reichweitenmessung:</strong> Wir verwenden eine eigene Besucherzählung, ohne Cookie und ohne personenbezogene Daten. Weder Ihre IP-Adresse noch Ihr Verlauf werden gespeichert: Es entstehen ausschließlich aggregierte, anonyme Statistiken (Seitenaufrufe, Besucher pro Tag). Eine Wiedererkennung von einem Tag auf den anderen oder über mehrere Websites hinweg ist damit nicht möglich, und Sie können der Messung jederzeit über den Link „Meine Cookies verwalten“ am Seitenende widersprechen.' },
        ],
      },
      {
        titre: '4. Ihre Rechte (DSGVO)',
        blocs: [
          { p: 'Als in Europa ansässige Person haben Sie folgende Rechte:' },
          {
            liste: [
              '<strong>Auskunftsrecht:</strong> Sie können Auskunft über Ihre personenbezogenen Daten verlangen',
              '<strong>Recht auf Berichtigung:</strong> Sie können unrichtige Daten berichtigen lassen',
              '<strong>Recht auf Löschung:</strong> Sie können die Löschung Ihrer Daten verlangen',
              '<strong>Recht auf Einschränkung:</strong> Sie können die Verarbeitung Ihrer Daten einschränken',
              '<strong>Recht auf Datenübertragbarkeit:</strong> Sie können Ihre Daten in einem strukturierten Format erhalten',
              '<strong>Widerspruchsrecht:</strong> Sie können der Verarbeitung Ihrer Daten widersprechen',
            ],
          },
          { p: `Zur Ausübung dieser Rechte wenden Sie sich an ${COURRIEL}.` },
        ],
      },
      {
        titre: '5. Datensicherheit',
        blocs: [
          { p: 'MirumGames.com trifft angemessene technische und organisatorische Sicherheitsmaßnahmen zum Schutz Ihrer Daten:' },
          {
            liste: [
              'SSL/TLS-Verschlüsselung aller Verbindungen',
              'Eingeschränkter Zugriff auf personenbezogene Daten',
              'Regelmäßige Datensicherungen',
              'Einhaltung der DSGVO',
            ],
          },
        ],
      },
      {
        titre: '6. Speicherdauer',
        blocs: [
          { p: 'Ihre personenbezogenen Daten werden so lange gespeichert, wie es erforderlich ist für:' },
          {
            liste: [
              'Die Abwicklung Ihrer Bestellung und der Gewährleistung',
              'Die Einhaltung gesetzlicher Pflichten (insbesondere steuerlicher)',
              'Die Verwaltung Ihres Kundenkontos',
            ],
          },
          { p: 'Nach Ablauf dieser Frist werden Ihre Daten gelöscht oder anonymisiert.' },
        ],
      },
      {
        titre: '7. Dritte',
        blocs: [
          { p: 'MirumGames.com kann Ihre Daten an folgende Dienstleister weitergeben:' },
          {
            liste: [
              '<strong>STRIPE</strong>: für die Zahlungsabwicklung',
              '<strong>Sendcloud</strong>: für Versand und Zustellung',
              '<strong>Sentry</strong>: für die Meldung technischer Fehler der Website. Übermittelt werden nur die zur Diagnose einer Störung erforderlichen Angaben; eine Aufzeichnung Ihrer Navigation findet nicht statt.',
              '<strong>Hosting</strong>: für die Speicherung der Website und der Daten',
            ],
          },
          { p: 'Alle diese Dienstleister sind zur Vertraulichkeit Ihrer Daten verpflichtet.' },
        ],
      },
      {
        titre: '8. Kontakt',
        blocs: [
          { p: 'Bei Fragen zum Datenschutz wenden Sie sich an:' },
          { p: `<strong>Verantwortlicher:</strong> Sébastien Schoonjans (MirumGames.com)<br /><strong>E-Mail:</strong> ${COURRIEL}<br /><strong>Adresse:</strong> ${ADRESSE}` },
          { p: 'Die Daten der bestehenden Kundenkonten wurden am 23.09.2026 zusammen mit dem Geschäftsbetrieb der Website von Sébastien Schoonjans übernommen.' },
        ],
      },
    ],
  },

  mentions: {
    seoTitre: 'Impressum',
    seoDescription:
      'Impressum von MirumGames: Unternehmensangaben, Inhaber der Website, USt-IdNr. und Kontaktdaten.',
    titre: 'Impressum',
    maj: 'Letzte Aktualisierung: 23.09.2026',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: 'Angaben zum Unternehmen',
        blocs: [
          {
            encadre: encadreIdentite({
              nom: 'Name des Unternehmens',
              statut: 'Rechtsform',
              statutValeur: 'selbstständiger Einzelunternehmer (natürliche Person)',
              adresse: 'Adresse',
              pays: 'Belgien',
              bce: 'Unternehmensnummer (ZDU)',
              tva: 'USt-IdNr.',
              email: 'E-Mail',
              telephone: 'Telefon',
              sep: ':',
            }),
          },
        ],
      },
      {
        titre: 'Verantwortlich für den Inhalt',
        blocs: [
          { p: '<strong>Sébastien Schoonjans</strong><br />Verantwortlich für die Veröffentlichung von MirumGames.com' },
        ],
      },
      {
        titre: 'Hosting der Website',
        blocs: [
          { p: 'MirumGames.com wird gehostet von:<br /><strong>Cloudflare Pages</strong> (öffentliche Oberfläche)<br /><strong>Dedizierter Server</strong> (Anwendung und Datenbank)<br /><br />Die Daten werden in der Europäischen Union gehostet und gemäß DSGVO verarbeitet.' },
        ],
      },
      {
        titre: 'Geistiges Eigentum',
        blocs: [
          { p: 'Sämtliche Inhalte von MirumGames.com (Texte, Bilder, Illustrationen, Logos, Videos usw.) sind durch das Recht des geistigen Eigentums geschützt.' },
          { p: 'Jede Vervielfältigung, Wiedergabe, Änderung, Veröffentlichung oder Anpassung der Website oder von Teilen davon, gleich mit welchen Mitteln, ist ohne vorherige schriftliche Zustimmung des Betreibers der Website, Sébastien Schoonjans, untersagt.' },
        ],
      },
      {
        titre: 'Steuern und Abgaben',
        blocs: [
          { p: 'Wir weisen darauf hin, dass unsere Preise die in Belgien geltenden Steuern und Abgaben enthalten. Die Rechtslage ist von Land zu Land unterschiedlich.' },
          { p: 'Die Käuferin oder der Käufer prüft, ob im eigenen Wohnsitzland weitere Steuern oder Abgaben anfallen, und entrichtet gegebenenfalls sämtliche Abgaben, Steuern und Gebühren für die in das eigene Land eingeführten Produkte.' },
        ],
      },
      {
        titre: 'Haftungsbeschränkung',
        blocs: [
          { p: 'Der Betreiber der Website bemüht sich, die hier veröffentlichten Informationen richtig und aktuell zu halten, und behält sich vor, den Inhalt jederzeit und ohne Vorankündigung zu berichtigen.' },
          { p: 'Der Betreiber kann jedoch die Richtigkeit, Genauigkeit oder Vollständigkeit der bereitgestellten Informationen nicht gewährleisten.' },
        ],
      },
      {
        titre: 'Cookies und personenbezogene Daten',
        blocs: [
          { p: 'Alle Informationen zur Verwendung von Cookies und zum Schutz Ihrer personenbezogenen Daten finden Sie in unserer <a href="/privacy" class="text-blue-600 hover:text-blue-800 underline">Datenschutzerklärung</a>.' },
        ],
      },
      {
        titre: 'Anwendbares Recht',
        blocs: [
          { p: 'Dieses Impressum unterliegt belgischem Recht. Im Streitfall wendet sich die Verbraucherin oder der Verbraucher vorrangig an MirumGames.com, um eine gütliche Lösung zu erreichen.' },
          { p: 'Andernfalls wird der Streit der ausschließlichen Zuständigkeit der zuständigen belgischen Gerichte unterworfen.' },
        ],
      },
      {
        titre: 'Kontakt',
        blocs: [
          { p: `Bei Fragen zu diesem Impressum erreichen Sie uns unter:<br /><strong>E-Mail:</strong> ${COURRIEL}<br /><strong>Adresse:</strong> ${ADRESSE}<br /><strong>Telefon:</strong> ${TELEPHONE}` },
        ],
      },
    ],
  },

  paiement: {
    seoTitre: 'Sicher bezahlen',
    seoDescription:
      'Zahlungssicherheit bei MirumGames: Abwicklung über Stripe, SSL/TLS-Verschlüsselung, PCI-DSS-Zertifizierung und praktische Hinweise.',
    titre: 'Sicher bezahlen',
    maj: 'Letzte Aktualisierung: 18.02.2024',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: 'Zahlung über STRIPE',
        blocs: [
          { p: 'Die Sicherheit von Kartenzahlungen hat höchste Bedeutung. MirumGames.com setzt dafür auf die Expertise von STRIPE, um Ihre Zahlungen bestmöglich zu schützen.' },
        ],
      },
      {
        titre: 'Ist die Zahlung bei MirumGames sicher?',
        blocs: [
          { p: 'Ja. Während der Zahlung läuft die gesamte Transaktion verschlüsselt über STRIPE. Sie verlassen MirumGames.com kurz und vollständig transparent, um Ihre Bankdaten einzugeben.' },
          { p: 'Damit ist sichergestellt, dass:' },
          {
            liste: [
              'MirumGames.com Ihre Kartennummer nie erfährt und keinen Zugriff auf Ihre Bankdaten hat',
              'MirumGames.com die Einzelheiten Ihrer Transaktionen nicht kennt — an uns werden nur der Gesamtbetrag und die Bestellnummer übermittelt',
              'Ihre Bankdaten ausschließlich von STRIPE verarbeitet werden, einem zertifizierten und vertrauenswürdigen Dienstleister',
            ],
          },
        ],
      },
      {
        titre: 'Welche Sicherheitsmaßnahmen trifft STRIPE?',
        blocs: [
          { p: 'STRIPE verwendet das standardisierte Verschlüsselungsverfahren, bekannt als „SSL-Protokoll“ (Secure Sockets Layer).' },
          { p: 'Prüfen Sie auf der Zahlungsseite diese Sicherheitsmerkmale:' },
          {
            liste: [
              '<strong>Sicherheitssymbol:</strong> In der Ecke Ihres Browsers muss ein geschlossenes Schloss erscheinen',
              '<strong>Adresszeile:</strong> Die URL muss mit „https://“ beginnen (nicht mit „http://“)',
              'Das „s“ in https steht für eine gesicherte, verschlüsselte Verbindung',
            ],
          },
          { p: 'Erscheint eine Warnmeldung, wechseln Sie von einem verschlüsselten in einen unverschlüsselten Modus (oder umgekehrt). Prüfen Sie das in diesem Fall, bevor Sie vertrauliche Daten eingeben.' },
        ],
      },
      {
        titre: 'Zertifizierungen von STRIPE',
        blocs: [
          { p: 'STRIPE erfüllt die strengsten Standards:' },
          {
            liste: [
              '<strong>PCI-DSS</strong> (Payment Card Industry Data Security Standard): höchste Sicherheitszertifizierung für Kartenzahlungen',
              '<strong>DSGVO</strong>: vollständige Einhaltung der europäischen Vorgaben',
              '<strong>ISO 27001</strong>: Zertifizierung für Informationssicherheits-Management',
              '<strong>SOC 2 Type II</strong>: unabhängiges Sicherheits- und Compliance-Audit',
            ],
          },
        ],
      },
      {
        titre: 'Sicherheitsempfehlungen',
        blocs: [
          { p: 'Für eine sichere Zahlung:' },
          {
            liste: [
              '✓ Verwenden Sie stets die aktuelle Version Ihres Browsers',
              '✓ Zahlen Sie nur über gesicherte Verbindungen (nicht über ungesichertes öffentliches WLAN)',
              '✓ Prüfen Sie immer, ob das Schloss geschlossen ist und die URL mit „https://“ beginnt',
              '✓ Geben Sie Ihre Zahlungsdaten niemals per E-Mail oder Telefon weiter',
              '✓ Kontrollieren Sie Ihre Kontoauszüge regelmäßig auf verdächtige Vorgänge',
            ],
          },
        ],
      },
      {
        titre: 'Was passiert nach der Zahlung?',
        blocs: [
          { p: 'Sobald die Zahlung bestätigt ist:' },
          {
            liste: [
              'Sie erhalten eine Bestellbestätigung per E-Mail',
              'MirumGames.com erhält ausschließlich den Gesamtbetrag und Ihre Bestellnummer',
              'STRIPE speichert Ihre Zahlungsdaten sicher',
              'Ihre Bestellung wird vorbereitet und versandt',
            ],
          },
        ],
      },
      {
        titre: 'Im Problemfall',
        blocs: [
          { p: 'Wenn Sie verdächtige Vorgänge auf Ihrem Konto feststellen:' },
          {
            liste: [
              'Wenden Sie sich umgehend an Ihre Bank',
              `Senden Sie eine E-Mail an ${COURRIEL} mit den Einzelheiten`,
              'Melden Sie das Problem direkt an STRIPE',
            ],
          },
        ],
      },
      {
        titre: 'Häufige Fragen',
        blocs: [
          { p: '<strong>F: Speichert MirumGames.com meine Kartendaten?</strong><br />A: Nein, auf keinen Fall. Ihre Bankdaten verwaltet allein STRIPE.' },
          { p: `<strong>F: Wie kann ich meine Zahlungsdaten löschen lassen?</strong><br />A: Wenden Sie sich an ${COURRIEL}, um die Löschung Ihrer Daten zu verlangen.` },
          { p: '<strong>F: Kann ich mehrere Zahlungsmethoden nutzen?</strong><br />A: Ja. STRIPE akzeptiert Kredit- und Debitkarten sowie je nach Standort weitere Methoden.' },
        ],
      },
      {
        titre: 'Weitere Informationen',
        blocs: [
          { p: 'Mehr Details zur Sicherheit bei STRIPE finden Sie unter: <a href="https://stripe.com/security" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">stripe.com/security</a>' },
        ],
      },
    ],
  },
};
